module.exports = __webpack_public_path__ + "img/sales_promotions_ch.bc1c59af.png";